/**
 * @deprecated This file is kept for backward compatibility.
 * Please import from './constants/index.js' instead.
 *
 * Example:
 *   import constants from './constants';
 *   // or
 *   import { PAGES_DATA, GROUPS_OF_PAGES } from './constants';
 */

import defaultExport from './constants/index';

// Re-export everything from the new modular structure
export * from './constants/index';

export default defaultExport;
